import React, { useEffect, useRef } from 'react';
import PureVideo from '@base/lib/PureVideo';
import { useBlackFridayCheckInProps } from '@base/activity/blackFridayCheckIn/useBlackFridayCheckIn';
import Image from '@base/lib/ThemeImage';
import { isVideoUrl } from 'base/utils/file';

type IProps = {
    checkIn: useBlackFridayCheckInProps
}

const VideoWrap: React.FC<IProps> = (props) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    const { checkIn } = props
    const { currentVideoUrl, playCount, progressData } = checkIn
    const { nowProcessCheckInStatus } = progressData || {}

    useEffect(() => {
        if (playCount) {
            videoRef.current && videoRef.current.play();
        }
    }, [playCount])

    const isVideo = isVideoUrl(currentVideoUrl?.[0])

    return (
        <>
            {currentVideoUrl && (
                <>{
                    isVideo ? (
                        <PureVideo
                            ref={videoRef}
                            key={currentVideoUrl?.[0]}
                            control={!!nowProcessCheckInStatus}
                            src={currentVideoUrl}
                        />
                    ) : (
                        <Image
                            width={825}
                            height={468}
                            background={false}
                            src={currentVideoUrl?.[0]}
                        />
                    )
                }
                </>
            )}

        </>
    );
};

export default VideoWrap